import logo from '../../logo.svg';
import { useState } from 'react';
import LoginEmailForm from './LoginEmailForm';
import RegisterForm from './RegisterForm';
import { useTranslation } from 'react-i18next';
import { LanguageSelector } from '../elements/LanguageSelector';

export default function Login() {
    const { t } = useTranslation();

    const [showRegister, setShowRegister] = useState(false);

    const showRegisterForm = () => {
        setShowRegister(true);
    }

    const handleRegistration = () => {
        setShowRegister(false);
    }

    return (<><div className="red-background"></div>
        <div className="login-container">
            {/* <LanguageSelector /> */}
            <div className="logo">
                <img alt="Task-Gen" src= {logo}/>
            </div>
            { !showRegister &&
                <div className="login-email">
                    <LoginEmailForm />
                    <div className="register-action-container">
                        { t("You don't have an account?") }
                        <a onClick={ showRegisterForm } title={ t("Register as a new user") }>
                            { t("Register") }
                        </a>
                    </div>
                </div>
            }
            { showRegister && <RegisterForm registerCallback={ handleRegistration } />} 
        </div></>);
}
